/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-08 14:23:51
 * @LastEditors: liwg
 * @LastEditTime: 2022-07-10 10:04:13
 */

import { createI18n } from 'vue-i18n'

import { useLocaleStoreWithOut } from '../store/lang'
import { localeSetting } from '../settings/localeSetting'
import { setHtmlPageLang, setLoadLocalePool } from './helper'
import type { I18nOptions } from 'vue-i18n'
import type { App } from 'vue'

const { fallback, availableLocales } = localeSetting

async function createI18nOptions(): Promise<I18nOptions> {
  const { activeLang } = storeToRefs(useLocaleStoreWithOut())
  const locale = (unref(activeLang) || 'zh_CN') as LocaleType
  const defaultLocal = await import(`./lang/${locale}.ts`)
  const message = defaultLocal.default?.message ?? {}
  setHtmlPageLang(locale)
  setLoadLocalePool((loadLocalePool) => {
    loadLocalePool.push(locale)
  })

  return {
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale: fallback,
    messages: {
      [locale]: message
    },
    availableLocales,
    sync: true,
    silentTranslationWarn: true,
    warnHtmlMessage: false,
    missingWarn: false,
    silentFallbackWarn: true
  }
}

// eslint-disable-next-line import/no-mutable-exports
export let i18n: any

export async function setupI18n(app: App) {
  const options = await createI18nOptions()
  i18n = createI18n(options)
  app.use(i18n)
}
